import './suppressResizeObserverError'
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from './store/store'
import { Loader } from './shared'
import { applyTenantTheme } from './config/tenant/applyTheme'
import { clearChunkRecoveryFlag } from './shared/errorBoundary/ErrorBoundary'
import './scss/app.scss'

// Apply white-label theme + favicon + page title from REACT_APP_TENANT before
// the first render so SCSS variables and document.title are correct on paint.
applyTenantTheme()

// Reaching here means the app booted successfully — re-arm the one-shot
// chunk-recovery guard so a future stale deploy can clear caches + reload again.
clearChunkRecoveryFlag()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Suspense fallback={<Loader />}>
      <Provider store={store}>
        <App />
      </Provider>
    </Suspense>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
